<script>
	// The params prop contains values matched from the URL
	export let params = {}

	import {createEventDispatcher, onMount} from 'svelte';
	import {querystring, replace} from 'svelte-spa-router';
	import {
		carregarEditorTexto,
		ConteudoRelatorioProjeto,
		dadosUsuarioLS,
		enviarDadosFormulario,
		TipoPerfil,
		verificarSessionStorage
	} from '../../utils';
	import TBox from '../templates/TBox.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let tipoRelatorioASerCadastrado, visibilidadeRelatorio;

	let tiposRelatoriosProjeto = [];
	let informacosAPICache = {};
	let desabilitarBotaoSubmit = true;
	let flagVisibilidade = false;
	let editorCarregado = false;
	let prazoLimiteInicial, prazoLimiteFinal;
	let dadosUsuario;
	let tituloProjeto;

	onMount(async () => {
		if (!verificarSessionStorage('AVAL_TOKEN'))
			replace("/painel");

		informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));
		tiposRelatoriosProjeto = informacosAPICache.relatorios_projeto;

		prazoLimiteInicial = informacosAPICache.prazos.cadastro_relatorios_projeto_inicio;
		prazoLimiteFinal = informacosAPICache.prazos.cadastro_relatorios_projeto_fim;
		dadosUsuario = dadosUsuarioLS();

		tipoRelatorioASerCadastrado = dadosUsuario.perfil == TipoPerfil.DISCENTE ? 'RELATORIO_PROJETO_DISCENTE' : 'RELATORIO_PROJETO_COORDENADOR';

		let parametrosURL = new URLSearchParams($querystring);
		tituloProjeto = decodeURIComponent(escape(window.atob(parametrosURL.get('tp'))));
	});

	const carregarEditor = () => { 
		flagVisibilidade = true;
		desabilitarBotaoSubmit = false;

		if (editorCarregado == false) {
			if (dadosUsuario.perfil == TipoPerfil.DISCENTE) {
				if (params.modalidade == 'PD') {
					carregarEditorTexto('editor-descricao-relatorio', ConteudoRelatorioProjeto.bolsista_prodocencia, false, (valor) => editorCarregado = valor);
				} else {
					carregarEditorTexto('editor-descricao-relatorio', ConteudoRelatorioProjeto.discente_mon_eic_id, false, (valor) => editorCarregado = valor);
				}
			} else {
				if (params.modalidade == 'MON')
					carregarEditorTexto('editor-descricao-relatorio', ConteudoRelatorioProjeto.coordenador_monitoria, false, (valor) => editorCarregado = valor);
				else if (params.modalidade == 'PD')
					carregarEditorTexto('editor-descricao-relatorio', ConteudoRelatorioProjeto.coordenador_prodocencia, false, (valor) => editorCarregado = valor);
				else
					carregarEditorTexto('editor-descricao-relatorio', ConteudoRelatorioProjeto.coordenador_eic_id, false, (valor) => editorCarregado = valor);
			}
		}
	}

	async function submeterFormulario(event) {
		enviarDadosFormulario('POST', dispatch, replace, 'projetos/relatorios', 
			JSON.stringify({
				idProjeto: parseInt(params.idProjeto),
				tipo: tipoRelatorioASerCadastrado, 
				visibilidade: visibilidadeRelatorio,
				conteudo: editor.getData()
			}), 
			'O relatório foi adicionado ao projeto. O mesmo pode ser visualizado na listagem de relatórios do projeto (na visualização do projeto)', 
			'#/painel/projetos', 
			'#/painel');
	}
</script>

<TBox 
	titulo="Cadastro de Relatório de Projeto" 
	subtitulo="Insira as informações sobre o relatório" 
	largura="12" 
	deslocamento="0" 
	icone="relatorio">

	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<div class="columns">
			<div class="column">
				<div class="box">
					<p>Projeto: <strong>{ tituloProjeto }</strong></p>
					<p>Código: <strong>{ params.codigoProjeto }</strong></p>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={tipoRelatorioASerCadastrado} name="tipo" disabled>
						<option value="">Selecione o tipo de relatório...</option>
						{#each Object.entries(tiposRelatoriosProjeto) as [chave, valor]}
						<option value="{chave}" selected>{valor}</option>
						{/each}
					</select>
				</div>
			</div>
		</div>
		
		<div class="columns">
			<div class="column">
				<div class="notification is-danger is-light">Prazo para cadastro e alterações: de <strong>{prazoLimiteInicial}</strong> até <strong>{prazoLimiteFinal}</strong>.</div>
				<p class="has-text-info">Utilize o editor abaixo para editar/cadastrar o conteúdo do relatório. É possível cadastrar parcialmente e ir atualizando as informações até a data acima. DICA: A menos que você já possua todo o conteúdo a ser cadastrado salvo em algum arquivo, evite digitar tudo nesta tela pra evitar perda de dados em caso de mal funcionamento do navegador, queda de conexão com a internet, expiração de token etc. Em caso de problemas para cadastro, favor entrar em contato com o suporte.</p>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<button class="button is-info is-medium is-fullwidth py-6 {flagVisibilidade == true ? 'is-hidden' : ''}" on:click|preventDefault={carregarEditor}>Clique aqui para inserir o conteúdo do relatório</button>
				<textarea name="descricao" class="content editor-descricao-relatorio {flagVisibilidade == false ? 'is-hidden' : ''}"></textarea>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/" class="button is-black is-medium is-outlined is-fullwidth">Início</a>
				</p>
			</div>
			<div class="column">
				<p class="control">
					<a href="#/painel" class="button is-black is-medium is-outlined is-fullwidth">Painel</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth" disabled={desabilitarBotaoSubmit}>
						Cadastrar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>